import React, { useMemo } from 'react';

import { useFormState } from 'shared/hooks';
import useConsultData from 'features/consults/hooks/useConsultData';
import useConsultInitialFormState from 'features/consults/hooks/useConsultInitialFormState';

import QuestionsPanel from 'features/consults/components/tabFields/QuestionsPanel';

import { CONSULT_TABS } from 'features/consults/utils/constants';
import signatureFields from 'features/consults/shared/tabs/Signature/formFields';

import { getValidationSchema } from './validationSchema';
import impressionPanel from './data';

const Assessment = () => {
  const consultData = useConsultData(CONSULT_TABS.ASSESSMENT);
  const { consult } = consultData;
  
  const attestationValue = consult[CONSULT_TABS.SIGNATURE]?.[signatureFields.attestationOfConsultCompletion.name];
  const consultType = consult[CONSULT_TABS.DEMOGRAPHICS]?.consultType;
  
  const schema = useMemo(() => getValidationSchema(attestationValue, consultType), [attestationValue, consultType]);
  
  const { register, control, getValues, getFieldError, setFormValues } =
    useFormState(schema, { stateSlice: 'consults', showAsSnackbar: true });
    
  const {
    consultTabData,
    isEditable,
    handleFieldChange,
  } = useConsultData(CONSULT_TABS.ASSESSMENT, getValues);

  useConsultInitialFormState(consult.id, consultTabData, setFormValues);

  return (
    <QuestionsPanel
      {...impressionPanel(attestationValue, consultType)}
      control={control}
      register={register}
      onChange={handleFieldChange}
      getFieldError={getFieldError}
      disabled={!isEditable}
    />
  );
};

export default Assessment;
